import HeroSection from "@/components/sections/HeroSection";
import { ThemeToggle } from "@/components/ui/theme-toggle";
import FeaturesSection from "@/components/ui/features-8";
import ContentSection from "@/components/ui/content-3";
import TestimonialsSection from "@/components/testimonials";
import LandingFooter from "@/components/footer";
import PricingSection from "@/components/sections/PricingSection";
import HowItWorksSection from "@/components/sections/HowItWorksSection";
import ChromeExtensionSection from "@/components/sections/ChromeExtensionSection";
import FloatingInstallButton from "@/components/ui/FloatingInstallButton";

export default function Landing() {
  return (
    <div className="min-h-screen bg-background text-foreground overflow-hidden">
      {/* TODO: find out if toggle theme is needed */}
      {/* <ThemeToggle /> */}
      <HeroSection />
      <FeaturesSection />
      <ChromeExtensionSection />
      <HowItWorksSection />
      <PricingSection />
      <TestimonialsSection />
      <ContentSection />
      <LandingFooter />
      <FloatingInstallButton />
    </div>
  );
}
